<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation ref="navigation"></navigation>
    </div>
    <div class="sy_main">
      <div class="sy_position">
        您当前的位置：<router-link  :to="{ path: '/'}" >首页</router-link> &gt;&gt;
        <router-link  :to="{ path: '/regularExamination'}" >医师定期考核</router-link> &gt;&gt; 工作动态
      </div>
      <div class="sym_content2">
        <div class="symc2">
          <newsSimpleList :settings="tzggSettings"></newsSimpleList>
        </div>
        <!--右侧3竖模块-->
        <div class="symc_right">
          <login></login>
          <latestNewsSimple></latestNewsSimple>
        </div>
      </div>
      <div class=""></div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {getRecommendList} from '../api/api';
  import  header2 from '../components/Header2'
  import  latestNewsSimple from '../components/LatestNewsSimple'
  import  navigation from '../components/Navigation'
  import  footer1 from '../components/Footer1'
  import  login from '../components/Login'
  import  newsSimpleList from '../components/NewsSimpleList'
  import  perfectCourseSimpleList from '../components/PerfectCourseSimpleList'
  import  medicalDynamicNews from '../components/MedicalDynamicNews'
  export default {
    components: {
      header2,
      footer1,
      navigation,
      login,
      newsSimpleList,
      latestNewsSimple,
      medicalDynamicNews
    },
    data () {
      return {
        tzggSettings: {
          consultName:'工作动态 ',
          consultId: 47,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'orderWeight': true,
          orderPublishTime: true,
          pageNum:1,
          pageSize: 40
        },
        secondCarousel: null
      }
    },
    mounted () {
      document.getElementById("J_GotoTop").style.visibility="hidden";//隐藏在线客服
    },
    destroyed () {
      document.getElementById("J_GotoTop").style.visibility="visible" //显示在线客服
    },
    computed: {},
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>



// WEBPACK FOOTER //
// src/views/Ysdqkh-gzdt.vue